import { Injectable } from '@angular/core';
import {Api} from "../../core/api-common-service/api";
import {ApiService} from "../../core/api-common-service/api.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
      private _apiService: ApiService,
      private _api: Api
  ) { }

  
  /**
   * for counsellor login
   * @param data
   */
  signUp(data: any){
    return this._apiService.post(this._api.API.AUTH.SIGNUP,data);
  }

  /**
   * for counsellor login
   * @param data
   */
  login(data: any){
    return this._apiService.post(this._api.API.AUTH.LOGIN,data);
  }

  /**
   * for counsellor logout
   */
  logout(data: any){
    return this._apiService.post(this._api.API.AUTH.LOGOUT,data);
  }

  /**
   * for counsellor forgot password
   * @param data
   */
  forgotPassword(data: any){
    return this._apiService.post(this._api.API.AUTH.FORGOT_PASSWORD,data);
  }

  /**
   * for counsellor change password
   * @param data
   */
  changePassword(data: any){
    return this._apiService.post(this._api.API.AUTH.CHANGE_PASSWORD,data);
  }

  /**
   * for counsellor reset password
   * @param data
   */
  resetPassword(data: any){
    return this._apiService.post(this._api.API.AUTH.RESET_PASSWORD,data);
  }

  /**
   * Summary: For resend otp
   * @param data
   */
  resendOtp(data: any){
    return this._apiService.post(this._api.API.AUTH.RESEND_OTP,data);
  }

  /**
   * Summary: For verify otp
   * @param data
   */
  verifyOtp(data: any){
    return this._apiService.post(this._api.API.AUTH.VERIFY_ACCOUNT,data);
  }

  /**
   * Summary: this method is use for get role list
   */
  getRole(data: any){
      return this._apiService.post(this._api.API.COMMON.ROLE_LIST, data);
  }

  //  /**
  //  * Summary: View Profile details
  //  * @param data
  //  */
  // viewProfile(){
  //     return this._apiService.post(this._api.API.AUTH.VIEW_PROFILE,{});
  // }

  // /**
  //  * Summary: edit Profile details
  //  * @param data
  //  */
  // editProfile(data: any){
  //     return this._apiService.post(this._api.API.AUTH.EDIT_PROFILE,data);
  // }

  // getAvatarList(){
  //     return this._apiService.post(this._api.API.AUTH.AVATAR_LIST,{});
  // }
}
